import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { useI18n } from "vue-i18n";
import { useSettingsStore } from "@/stores/SettingsStore";
export default /*@__PURE__*/ _defineComponent({
    __name: 'OrderReceivedView',
    setup(__props) {
        const { t } = useI18n();
        const settingsStore = useSettingsStore();
        // Shops can configure an external page (e.g. their own thank-you page) that customers are forwarded to after booking
        const redirectLink = settingsStore.settings.get('booking_complete_redirect_link')?.value;
        if (redirectLink != null && redirectLink.length > 0) {
            window.location.href = redirectLink;
        }
        return (_ctx, _cache) => {
            const _component_v_container = _resolveComponent("v-container");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createElementVNode("h2", null, _toDisplayString(_unref(t)('orderReceived.title')), 1),
                _createVNode(_component_v_container, null, {
                    default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)('orderReceived.text')), 1)
                    ]),
                    _: 1
                })
            ], 64));
        };
    }
});
